import {
  RcfaCompliancePage as RcfaComplianceFeaturePage,
  useRcfaCompliancePageState,
  rcfaComplianceTimeRangeMapper
} from '@features/rcfa-compliance'
import {getMaintainRcfaStoppageListUrl, getSystemTimezone} from '@hconnect/common/utils'
import {useUpmPlantsContext} from '@hconnect/upm'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'

import {
  useTrackRcfaComplianceAnalyticsGeneralEvent,
  RcfaComplianceEventName
} from '../../performanceDashboard/helpers'
import {useTranslationPrefix} from '../../shared/hooks/useTranslationPrefix'

export const RcfaCompliancePage = () => {
  const {timeRange} = useRcfaCompliancePageState()
  const timezone = getSystemTimezone()
  const upmPlants = useUpmPlantsContext()

  const trackRcfaComplianceEvent = useTrackRcfaComplianceAnalyticsGeneralEvent()
  useEffect(() => {
    trackRcfaComplianceEvent(RcfaComplianceEventName.userEntersRcfaCompliancePage, {})
  }, [trackRcfaComplianceEvent])

  const {t} = useTranslation()
  const {hrocPrefix} = useTranslationPrefix()

  const onPlantItemClick = (upmPlantId: string) => {
    if (!upmPlants) return

    // to be removed after stoppages list page supports receiving upmPlantId instead of plantId
    const upmPlant = Object.values(upmPlants).find((p) => p.upmId === upmPlantId)
    if (!upmPlant) return

    const url = getMaintainRcfaStoppageListUrl(
      upmPlant.plantId,
      timezone,
      timeRange,
      rcfaComplianceTimeRangeMapper
    )
    // navigate to different feature
    window.location.assign(url)
  }

  return (
    <RcfaComplianceFeaturePage
      titleSlot={t(`${hrocPrefix}.rcfaCompliance.pageTitle`)}
      onPlantItemClick={onPlantItemClick}
      inverted
    />
  )
}
